        
                  <div class="card">
                    <h3>{{ scancode }}</h3>
                    <div class="row">
                    <div class="col-sm-2">
                    <button class="btn btn-primary " (click)="validSubmit()"> &nbsp;  &nbsp;Scan  &nbsp;&nbsp;</button>
                  </div>
                  <div class="col-sm-2">
                    <button class="btn btn-primary " (click)="stopScanning()"> &nbsp; &nbsp;Close  &nbsp;&nbsp;</button>
                  </div>
                </div>                                </div>
                <video #videoPreview></video>
